var Backbone = require('backbone')

module.exports = Backbone.Model.extend({
  fetchList: function(options) {
    return $.ajax({ url: options.url })
  }
})
